import { Badge, Flex, Text, Tooltip } from "@mantine/core";

export interface TagLike {
  value?: string;
  _id?: string;
  label?: string;
  name?: string;
  kind?: string;
  color?: string;
}

interface Props {
  tags?: TagLike[];
  /** Bu sayıdan fazlası "+N" olarak toplanır */
  max?: number;
  emptyText?: string;
}

// Etiket rengi belirtilmemişse türe göre sabit bir renk kullanılır; böylece
// rol / yetenek / serbest etiket bir bakışta ayırt edilebilir.
const KIND_COLORS: Record<string, string> = {
  role: "#5C26FF",
  skill: "#0EA5E9",
  custom: "#64748B",
  department: "#16A34A",
  contract: "#D97706",
};

const colorOf = (tag: TagLike) =>
  tag.color || KIND_COLORS[tag.kind ?? "custom"] || KIND_COLORS.custom;

const labelOf = (tag: TagLike) => tag.label ?? tag.name ?? "";

/**
 * Rol, yetenek, serbest etiket, departman ve kontratın hepsi bu bileşenle
 * gösterilir — kullanıcı açısından tek bir "etiket şeridi", veri modelinde ayrı.
 */
const TagBadges = ({ tags, max = 3, emptyText = "-" }: Props) => {
  const list = (tags ?? []).filter(Boolean);

  if (list.length === 0) {
    return (
      <Text size="md" fw={400} c="dimmed">
        {emptyText}
      </Text>
    );
  }

  const visible = list.slice(0, max);
  const hidden = list.slice(max);

  return (
    <Flex gap={6} wrap="wrap" align="center">
      {visible.map((tag, i) => (
        /*
         * ANAHTARDA KONUM DA VAR (`-${i}`). Yalnızca id kullanmak tekrarlanan
         * anahtar uyarısı üretiyordu: rapor uçları etiketi yalnızca ADIYLA
         * döndürüyor ve `LabelCell` adı kayda çeviriyor — aynı ada sahip bir
         * ROL ile bir YETENEK varsa ikisi de aynı kayda, dolayısıyla aynı id'ye
         * çözülüyor. Bu meşru bir veri durumu (şirket "Kaynakçı" adında hem rol
         * hem yetenek tanımlayabilir), o yüzden ayıklamak yerine anahtarı
         * konumla benzersizleştiriyoruz; iki rozet de görünmeye devam ediyor.
         */
        <Badge
          key={`${tag.value ?? tag._id ?? "etiket"}-${i}`}
          radius="sm"
          variant="light"
          color={colorOf(tag)}
          styles={{ label: { textTransform: "none", fontWeight: 500 } }}
        >
          {labelOf(tag)}
        </Badge>
      ))}
      {hidden.length > 0 && (
        <Tooltip label={hidden.map(labelOf).join(", ")} withArrow>
          <Badge radius="sm" variant="outline" color="gray">
            +{hidden.length}
          </Badge>
        </Tooltip>
      )}
    </Flex>
  );
};

export default TagBadges;
